import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Fragment } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import SlideTitle from "../slide-title/SlideTitle";
import SlideImage from "../slide-image/SlideImage";
import SlideBody from "../slide-body/SlideBody";
import SlideCloseIcon from "../slide-close-icon/SlideCloseIcon";

var TextImageSlideBody = function TextImageSlideBody(_ref) {
  var classes = _ref.classes,
      slide = _ref.slide,
      shouldAnimate = _ref.shouldAnimate,
      rest = _objectWithoutProperties(_ref, ["classes", "slide", "shouldAnimate"]);

  var imgSrc = slide.imgSrc,
      headline = slide.headline,
      primaryColour = slide.primaryColour,
      contrastColour = slide.contrastColour,
      headlineColor = slide.headlineColor,
      roundImage = slide.roundImage;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContainer,
    style: {
      backgroundColor: primaryColour
    }
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: true,
    style: {
      color: contrastColour,
      backgroundColor: primaryColour
    }
  }), /*#__PURE__*/React.createElement(SlideImage, {
    imgSrc: imgSrc,
    primaryColour: primaryColour,
    shouldAnimate: shouldAnimate,
    roundImage: roundImage
  }), /*#__PURE__*/React.createElement(SlideCloseIcon, Object.assign({
    slide: slide
  }, rest))), /*#__PURE__*/React.createElement("div", {
    className: classes.headlineContainer
  }, /*#__PURE__*/React.createElement(SlideBody, {
    headline: headline,
    shouldAnimate: shouldAnimate,
    color: headlineColor
  })));
};

var styles = {
  headerContainer: {
    height: "60%",
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "hidden"
  },
  "@media screen and (min-width: 450px)": {
    headerContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    }
  },
  headlineContainer: {
    display: "flex",
    flexBasis: "25%"
  }
};
export default withStyles(styles)(TextImageSlideBody);